const NETWORK = 'networks';

export const CATEGORY_ACTOR = {
	ACTION: 'action',
	ADVANCED: 'advanced',
	ANIMATION: 'animation',
	AUDIO: 'audio',
	COMPUTER_VISION: 'computer vision',
	CONVERSION: 'conversion',
	EVENTS: 'events',
	FLOW: 'flow',
	GET: 'get',
	INPUTS: 'inputs',
	LOGIC: 'logic',
	MAPS: 'maps',
	MATH: 'math',
	NETWORK,
	MISC: 'misc',
	PARTICLES: 'particles',
	PHYSICS: 'physics',
	WEBXR: 'webXR',
};

export const CATEGORY_ANIM = {
	MISC: 'misc',
	MODIFIER: 'modifiers',
	NETWORK,
	PROP: 'prop',
	SUBNET: 'subnet',
	TIMING: 'timing',
};
export const CATEGORY_AUDIO = {
	ANALYSER: 'analyser',
	EFFECTS: 'effects',
	INPUTS: 'inputs',
	INSTRUMENTS: 'instruments',
	MISC: 'misc',
	NETWORK,
};
export const CATEGORY_CAD = {
	ADVANCED: 'advanced',
	EXTRUDE: 'extrude',
	FLOW: 'flow',
	MODIFIER: 'modifiers',
	PRIMITIVES_2D: 'primitives 2D',
	PRIMITIVES_3D: 'primitives 3D',
	TRANSFORM: 'transform',
	NETWORK,
};
export const CATEGORY_COP = {
	ADVANCED: 'advanced',
	SDF: 'SDF',
	FILTER: 'filters',
	INPUT: 'inputs',
	MAPS: 'maps',
	MISC: 'misc',
	NETWORK,
};
export const CATEGORY_CSG = {
	ADVANCED: 'advanced',
	EXTRUDE: 'extrude',
	FLOW: 'flow',
	MODIFIER: 'modifiers',
	PRIMITIVES_2D: 'primitives 2D',
	PRIMITIVES_3D: 'primitives 3D',
	TRANSFORM: 'transform',
	NETWORK,
};
export const CATEGORY_EVENT = {
	ADVANCED: 'advanced',
	CAMERA: 'cameras',
	INPUT: 'inputs',
	MISC: 'misc',
	SCENE: 'scene',
	NETWORK,
};
export const CATEGORY_GL = {
	ADVANCED: 'advanced',
	COLOR: 'color',
	CONVERSION: 'conversion',
	DYNAMICS: 'dynamics',
	GEOMETRY: 'geometry',
	GLOBALS: 'globals',
	LIGHTING: 'lighting',
	LOGIC: 'logic',
	MATH: 'math',
	PHYSICS: 'physics',
	QUAT: 'quat',
	SDF_PRIMITIVES_2D: 'SDF prims 2D',
	SDF_PRIMITIVES: 'SDF prims 3D',
	SDF_MODIFIERS: 'SDF modifiers',
	TRIGO: 'trigo',
	UTIL: 'util',
	INSTANCE: 'instance',
	NETWORK,
};
export const CATEGORY_JS = {
	ACTION: 'action',
	ADVANCED: 'advanced',
	ANIMATION: 'animation',
	AUDIO: 'audio',
	COLOR: 'color',
	COMPUTER_VISION: 'computer vision',
	CONVERSION: 'conversion',
	DYNAMICS: 'dynamics',
	EVENTS: 'events',
	FLOW: 'flow',
	GEOMETRY: 'geometry',
	GET: 'get',
	GLOBALS: 'globals',
	INPUTS: 'inputs',
	LOGIC: 'logic',
	MATH: 'math',
	PARTICLES: 'particles',
	PHYSICS: 'physics',
	QUAT: 'quat',
	SDF_PRIMITIVES_2D: 'SDF prims 2D',
	SDF_PRIMITIVES: 'SDF prims 3D',
	SDF_MODIFIERS: 'SDF modifiers',
	TRIGO: 'trigo',
	UTIL: 'util',
	INSTANCE: 'instance',
	WEBXR: 'webXR',
	WFC: 'WFC',
};
export const CATEGORY_MAT = {
	ADVANCED: 'advanced',
	INSTANCE: 'instances',
	LINE: 'lines',
	MESH: 'meshes',
	NETWORK,
	POINTS: 'points',
	UPDATE: 'update',
	VOLUME: 'volumes',
};
export const CATEGORY_OBJ = {
	ADVANCED: 'advanced',
	AUDIO: 'audio',
	CAMERA: 'cameras',
	GEOMETRY: 'geometries',
	LIGHT: 'lights',
	NETWORK,
	TRANSFORM: 'transform',
};
export const CATEGORY_ROP = {
	CSS: 'css',
	NETWORK,
	WEBGL: 'webgl',
};

export const CATEGORY_SOP = {
	ADVANCED: 'advanced',
	ANIMATION: 'animation',
	ATTRIBUTE: 'attributes',
	AUDIO: 'audio',
	CAD: 'CAD',
	CAMERA: 'cameras',
	CSG: 'CSG',
	COMPUTER_VISION: 'computer vision',
	DYNAMICS: 'dynamics',
	FLOW: 'flow',
	HELPERS: 'helpers',
	INPUT: 'inputs',
	INSTANCE: 'instance',
	LIGHTS: 'lights',
	MAPS: 'maps',
	MISC: 'misc',
	MODIFIER: 'modifiers',
	NETWORK,
	OUTPUT: 'outputs',
	PHYSICS: 'physics',
	PRIMITIVES_2D: 'primitives 2D',
	PRIMITIVES: 'primitives 3D',
	QUAD: 'QUAD',
	RENDER: 'render',
	SDF: 'SDF',
	SUBNET: 'subnet',
	TET: 'TET',
	WEBXR: 'webXR',
	WFC: 'WFC',
};
export const CATEGORY_POST = {
	ADVANCED: 'advanced',
	BLUR: 'blur',
	COLOR: 'color',
	EFFECT: 'effect',
	MISC: 'misc',
	NETWORK,
};
